import * as React from 'react';

function Virtuals(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.861 4H7.857c-.71 0-1.426.428-1.602 1.135L3.04 18.454c-.177.705.254 1.511.96 1.511h13.003c.712 0 1.427-.88 1.5-1.584L21.72 5.288c.182-.81-.153-1.288-.86-1.288zM13.35 15.483c-.263.444-.567.747-.91.906-.344.162-.797.24-1.363.24-.268 0-.525-.014-.784-.046a3.043 3.043 0 01-.724-.176l-.756-10.07c.204-.086.444-.15.724-.186a6.37 6.37 0 01.806-.054c.136 0 .28.009.426.031.14.023.272.06.385.114a.74.74 0 01.285.23c.073.1.118.236.127.408l.163 3.414a107.224 107.224 0 01.132 3.799c.171-.353.338-.68.502-.992l.489-.92c.163-.302.326-.606.498-.914.167-.308.348-.638.548-.991l1.87-3.35a1.496 1.496 0 01.752-.693c.14-.06.289-.096.443-.113.154-.014.303-.023.453-.023.19 0 .412.018.656.054.245.036.444.09.598.154l-5.32 9.178z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Virtuals;
